import React, { useEffect, useState } from "react";
import PageHeader from "../../components/heading";
import SearchBar from "../../components/searchBar";
import { useTranslation } from "react-i18next";
import FolderPageListTable from "../projects/projectPage/FolderPageListTable";
import { Spinner } from "react-bootstrap";
import NoPages from "../projects/projectPage/noPages";
import { useDebounceEffect } from "../../hooks/useDebounceEffect";
import ImgPage from "./img/test-page.png";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import { PagesDocument, usePagesQuery } from "../../graphql/page.hooks";
import { useDeletePage2Mutation } from "../../graphql/projects.hooks";
import Pagination from "../../components/pagination";
import { IMoveItems } from "../../types";

export const AllPages = () => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();

  const projectSettings = JSON.parse(localStorage.getItem("mePageSettings"));
  const [currentPage, setCurrentPage] = useState(
    projectSettings?.projectPage?.currentPage || 1
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState<"grid" | "table">("table");
  const [limit, setLimit] = useState(projectSettings?.projectPage?.limit || 12);
  const [selectedItems, setSelectedItems] = useState<IMoveItems>({
    pageIds: [],
    folderIds: [],
  });

  const {
    data: pages,
    loading,
    refetch,
  } = usePagesQuery({
    variables: {
      page: currentPage,
      limit,
      search: searchTerm || null,
    },
  });

  const refetchAllPagesWithCredentials = () => {
    refetch({
      search: searchTerm,
      page: currentPage,
      limit,
    });
  };

  const [deletePage] = useDeletePage2Mutation({
    refetchQueries: [
      {
        query: PagesDocument,
        variables: {
          page: currentPage,
          limit,
          search: searchTerm || null,
        },
      },
    ],
  });

  useEffect(() => {
    document.title = "All Pages";
  }, []);

  const pagination = pages?.pages.paginator;
  const pageCount = pagination?.totalPages || 0;
  const totalItems = pagination?.totalItemCount || 0;
  const firstItemIndex = pagination
    ? (currentPage - 1) * pagination.itemNumberPerPage + 1
    : 0;
  const lastItemIndex = pagination
    ? Math.min(currentPage * pagination.itemNumberPerPage, totalItems)
    : 0;

  const handleSearch = () => {
    setCurrentPage(1);
    refetch({
      search: searchTerm,
      page: currentPage,
      limit,
    });
  };

  useDebounceEffect(handleSearch, 1000, [searchTerm]);

  const handleLimitChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLimit = Number(event.target.value);
    setLimit(newLimit);
    setCurrentPage(1);
    refetch({
      search: searchTerm,
      page: 1,
      limit: newLimit,
    });
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    refetch({
      search: searchTerm,
      page: pageNumber,
      limit: limit,
    });
  };

  return (
    <>
      <PageHeader title={"All Pages"} paths={[]} isHiddenTryPro={true} />
      <SearchBar
        t={t}
        title={""}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        viewMode={viewMode}
        setViewMode={setViewMode}
        handleSearch={handleSearch}
        link={`${lng}/projects`}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        isDisabled={!pages?.pages?.pages}
        isAdminTable={true}
      />
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" />
        </div>
      ) : pages?.pages?.pages ? (
        <>
          <FolderPageListTable
            folders={[]}
            pages={pages?.pages?.pages}
            folderImgSrc={""}
            pageImgSrc={ImgPage}
            deletePage={deletePage}
            domainId={""}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            refetchAllPagesWithCredentials={refetchAllPagesWithCredentials}
            isAdminTable={true}
          />
          <div className="d-flex justify-content-between align-items-center bg-white px-4 py-3 mt-5 rounded">
            <Pagination
              t={t}
              pages={pageCount}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              firstItemIndex={firstItemIndex}
              lastItemIndex={lastItemIndex}
              totalItems={totalItems}
              limit={limit}
              onLimitChange={handleLimitChange}
            />
          </div>
        </>
      ) : (
        <NoPages domainId={""} folderId={""} />
      )}
    </>
  );
};
